// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-quinn-residences -> quinn-residences-websites -> quinn-residences-at-dorchester-place
// Generated: 2026-10-29T18:32:41.796Z
// Counts: 0 design, 45 content, 45 slot group, 0 collection binding, 6 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>3-, 4-, and 5-Bedroom Homes for Rent in Covington, GA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "easy-fee-guide-hero.lead": {
    "overrideType": "VALUE",
    "customValue": "<p>A simple breakdown of the fees, services, and optional costs associated with living at <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "easy-fee-guide-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Know your costs before you move in.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "engrain-sitemap.height": {
    "overrideType": "VALUE",
    "customValue": "1000",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.lead": {
    "overrideType": "VALUE",
    "customValue": "<p>Compare layouts, check availability, and find the space that fits how home needs to work.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "nextstep.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Find Your Space With Our Interactive Leasing Map</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourquestions.when_a": {
    "overrideType": "VALUE",
    "customValue": "<p>The scheduler shows the times you can book.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.widget.self_guided_tour_link": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_self_guided_tour_url"
  },
  "tourscheduler.widget.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.widget.use_leads_tour_times": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Modern Rental Home Amenities in Covington, GA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Every home comes ready for real life, with an in-unit washer and dryer, a dishwasher, efficient appliances, and a private fenced-in yard. Lawn maintenance is included and there's a trail to walk, so your weekends are yours. See everything on the <a href=\"/amenities\">amenities page</a>.</p>",
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Room to live, inside and out</p>",
    "mappedField": null
  },
  "amenityhighlights.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Dorchester Place is built around the outdoors: green space and walking trail access within the community, lawn maintenance that keeps every yard looking sharp, and quiet streets lined with front porches. Take a closer look in the <a href=\"/gallery\">gallery</a>.</p>",
    "mappedField": null
  },
  "amenityhighlights.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Thoughtful Features for Comfortable Everyday Living</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "aroundthearea.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover Shopping, Dining, and More Near Covington Square</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Contact Dorchester Place in Covington, GA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactdetails.title": {
    "overrideType": "VALUE",
    "customValue": "<p>We're Here to Help You Find Your Next Home</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "feetable.concierge_note": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Includes a bi-annual filter change, exterior pest control, 24-hour maintenance response for emergencies, and positive credit reporting.</p>",
    "mappedField": null
  },
  "floorplanshero.offer_label": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Free rent on select homes</p>",
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore Our Rental Home Photo Gallery</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Homes for Rent in Covington, GA</p>",
    "generatedValue": "<p>Brand-new rental homes in Covington, Georgia</p>",
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore Available Rental Homes in Covington, GA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemapcallout.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Find your open home, street by street.</p>",
    "mappedField": null
  },
  "lifestylehighlights.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>At Dorchester Place, the best parts of the week happen close to home: evenings in your own private fenced-in yard, walks on the community trail, and weekends free because lawn maintenance is handled. See everything that comes with each home on the <a href=\"/amenities\">amenities</a> page.</p>",
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Rental Homes Near Downtown Covington, GA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodcallout.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>From Brookhaven Drive it's a short drive to the restaurants and boutiques on the Square, the paved Cricket Frog Trail, and Oxford College of Emory University. You'll also find farmers market weekends and events at the Georgia International Horse Park nearby. Learn more about the <a href=\"/neighborhood\">neighborhood</a>.</p>",
    "mappedField": null
  },
  "neighborhoodcallout.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Minutes from Covington's Historic Square</p>",
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Pet-Friendly Homes for Rent in Covington, GA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.glance_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover More About Our Pet Policies</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Cats and dogs settle right in with a private fenced-in yard out back, green space around the community, and the paved Cricket Frog Trail nearby for longer walks. Get the details in our <a href=\"/pet-policy\">pet policy</a>.</p>",
    "mappedField": null
  },
  "petpolicy.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Room to roam for every pet</p>",
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Privacy Policy</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover Spacious Rental Homes at Dorchester Place</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank You for Reaching Out!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyou.title": {
    "overrideType": "VALUE",
    "customValue": "<p>We Look Forward to Connecting With You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourgallery.title": {
    "overrideType": "VALUE",
    "customValue": "<p>See What Makes Dorchester Place Feel Like Home</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Schedule a Tour of Our Covington Rental Homes</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "touroptions.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Walk through the Aspen, Hemingway, and Vera homes in 3D on our <a href=\"/virtual-tours\">virtual tours</a>, then see Dorchester Place in person on a <a href=\"/schedule-a-tour\">self-guided tour</a> or with our leasing team.</p>",
    "mappedField": null
  },
  "touroptions.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Find a Floor Plan That Fits Your Lifestyle</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tours-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Virtual Tours of Rental Homes in Covington, GA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourembed.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Step inside the Aspen, Hemingway, and Vera homes at Dorchester Place with 3D walkthroughs. Pick a plan to explore room by room, then compare details on our <a href=\"/floor-plans\">floor plans</a> page.</p>",
    "mappedField": null
  },
  "virtualtourembed.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore Our Spacious Homes From Anywhere</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactdetails.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "",
        "customValue": "/thank-you"
      }
    }
  },
  "floorplanshero.link_fees": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/easy-fee-guide"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "floorplanshero.link_pets": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/pet-policy"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "whyquinn.pillar_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Easy access to great schools, shopping, dining, and everyday essentials."
      }
    }
  },
  "whyquinn.pillar_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Spacious layouts that blend functionality, comfort, and modern style."
      }
    }
  },
  "whyquinn.pillar_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Community-Focused Amenities"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Shared spaces designed to bring neighbors together and create lasting memories."
      }
    }
  },
  "whyquinn.pillar_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Dedicated support and personalized service for a hassle-free rental experience."
      }
    }
  },
  "whyquinn.pillar_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Energy-efficient homes built to reduce environmental impact and help lower your utility costs."
      }
    }
  },
  "amenitieslist.amenity_photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Private Fenced-In Yard"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167648/01a15ab5-95a4-745c-91c7-d70910fb3ade.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of Dorchester Place homes with well-kept private yards"
      }
    }
  },
  "amenitieslist.amenity_photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Lawn Maintenance"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec36-3cc6-7758-972b-8d6509273cdb.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Single-family home with a covered front porch, trimmed lawn, and landscaping"
      }
    }
  },
  "amenitieslist.amenity_photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Smart-Home Technology"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec36-48ec-7323-abd7-1e9939b3444d.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open-concept living space with light wood floors, ceiling fan, and kitchen island"
      }
    }
  },
  "amenitieslist.amenity_photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Electronic Thermostat"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167648/01a15ab5-dd46-7038-aa3a-dff1aadcf8b3.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Interior view of a spacious open-concept living area and kitchen with wood-look flooring and modern finishes."
      }
    }
  },
  "amenitieslist.amenity_photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Cable Ready"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167648/01a15ab5-debc-77b3-97d3-f3df632f8855.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Spacious living area with hardwood floors, ceiling fan, and open kitchen."
      }
    }
  },
  "amenitieslist.amenity_photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "High Ceilings"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167648/01a15ab5-ced9-72bd-a84f-08dab6c26e8e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Interior of a bedroom with a tray ceiling and ceiling fan, and two dark wood doors."
      }
    }
  },
  "amenitieslist.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167648/01a15ab5-8d71-71dc-8a47-edeea5d6ef5b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of the Dorchester Place homes, yards, and green spaces in Covington"
      }
    }
  },
  "amenitygroups.community_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167648/01a15ab5-95a4-745c-91c7-d70910fb3ade.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of Dorchester Place homes with well-kept yards and quiet streets"
      }
    }
  },
  "amenitygroups.home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec36-3cd2-743d-b5ca-c11ba613ee44.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open-concept kitchen with a large island, white cabinets, stainless steel appliances and wood-look floors"
      }
    }
  },
  "amenityhighlights.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167648/01a15ab6-2d2a-71e1-ae51-6ece3a7fde03.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a serene neighborhood with winding roads, lush greenery, and a central park."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Green Space"
      }
    }
  },
  "amenityhighlights.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167648/01a15ab5-d03d-72a0-8613-398601130063.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior of a light blue single-family home with a covered front porch and manicured lawn."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Lawn Care"
      }
    }
  },
  "amenityhighlights.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167648/01a15ab6-0aec-71a9-a282-732eff0c7317.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior of a two-story house with a covered front porch and landscaping."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Front Porches"
      }
    }
  },
  "amenityhighlights.card_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167648/01a15ab5-cf4b-76eb-ac7e-909d078f6aa1.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior of a light blue house with a three-car garage and a covered porch."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Garages"
      }
    }
  },
  "amenityhighlights.card_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167648/01a15ab5-922e-739e-ae53-b3db15a3c717.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of Dorchester Place streets and single-family homes"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Neighborhood"
      }
    }
  },
  "amenityhighlights.card_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167648/01a15ab5-8de0-7454-abbb-8d66cc79769f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of Dorchester Place homes with private backyards and well-kept lawns"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Private Yards"
      }
    }
  },
  "floorplanshero.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec36-305d-7028-9a2e-24e8cc5f67eb.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two-story Dorchester Place rental home with a covered front porch and front yard"
      }
    }
  },
  "floorplanshero.photo_10": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec36-557a-70da-9438-8495b82fb4cd.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bedroom with a tray ceiling, crown molding, and a ceiling fan"
      }
    }
  },
  "floorplanshero.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec36-3cd2-743d-b5ca-c11ba613ee44.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open-concept living area and kitchen with a large island and wood-look floors"
      }
    }
  },
  "floorplanshero.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167648/01a15ab5-cf4b-76eb-ac7e-909d078f6aa1.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior of a light blue house with a three-car garage and a covered porch."
      }
    }
  },
  "floorplanshero.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec36-3b6f-75dd-8773-9a737fa92916.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen with granite countertops, stainless steel appliances, and a breakfast-bar island"
      }
    }
  },
  "floorplanshero.photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167648/01a15ab5-8de0-7454-abbb-8d66cc79769f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a suburban neighborhood with modern houses and well-maintained lawns."
      }
    }
  },
  "floorplanshero.photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec36-539c-75ee-8bb0-11df06489424.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Spacious living room flowing into the kitchen, with a staircase to the second floor"
      }
    }
  },
  "floorplanshero.photo_7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec36-4f86-7709-be0b-be460efb355d.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Farmhouse-style home with light blue siding, white columns, and a welcoming front entry"
      }
    }
  },
  "floorplanshero.photo_8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec36-48ec-7323-abd7-1e9939b3444d.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bright open living space with light wood floors, a ceiling fan, and a kitchen island"
      }
    }
  },
  "floorplanshero.photo_9": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167648/01a15ab5-d03d-72a0-8613-398601130063.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior of a light blue single-family home with a covered front porch and manicured lawn."
      }
    }
  },
  "lifestylehighlights.highlight_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Your Own Backyard"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Every home has a private fenced-in yard, and lawn maintenance is included, so your weekends go to relaxing instead of mowing."
      }
    }
  },
  "lifestylehighlights.highlight_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Out on the Trail"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "The community trail is where neighbors cross paths on morning walks, evening strolls, and loops with the dog."
      }
    }
  },
  "lifestylehighlights.highlight_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Room to Focus"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Select floor plans add flex space or a media room, so you can have a real home office with smart-home tech built in."
      }
    }
  },
  "neighborhoodcallout.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec33-c130-77bb-9612-07b990d84aed.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Newton County Turner Lake Park near Dorchester Place in Covington"
      },
      "caption": {
        "type": "GENERATOR",
        "generatedValue": "Newton County Turner Lake Park"
      }
    }
  },
  "petpolicy.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167648/01a15ab5-8d71-71dc-8a47-edeea5d6ef5b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a suburban neighborhood with well-maintained houses and green spaces."
      },
      "caption": {
        "type": "GENERATOR",
        "generatedValue": "Open green space"
      }
    }
  },
  "propertyoverview.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167648/01a15ab5-d03d-72a0-8613-398601130063.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior of a light blue single-family home with a covered front porch and manicured lawn."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Home Exterior"
      }
    }
  },
  "propertyoverview.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167648/01a15ab5-cf4b-76eb-ac7e-909d078f6aa1.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior of a light blue house with a three-car garage and a covered porch."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Three-Car Garage"
      }
    }
  },
  "propertyoverview.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec36-3cd2-743d-b5ca-c11ba613ee44.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open-concept living area with a kitchen island, stainless steel appliances, and wood-look floors"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Open Living Area"
      }
    }
  },
  "propertyoverview.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec36-3b6f-75dd-8773-9a737fa92916.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen with white cabinets, granite countertops, stainless steel appliances, and a breakfast bar island"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen"
      }
    }
  },
  "propertyoverview.photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec36-539c-75ee-8bb0-11df06489424.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A spacious living room with a staircase and a kitchen area."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Living Room"
      }
    }
  },
  "propertyoverview.photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec36-557a-70da-9438-8495b82fb4cd.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bedroom with a tray ceiling, ceiling fan, crown molding, and wood-look floors"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Bedroom"
      }
    }
  },
  "tourhero.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167648/019fec36-305d-7028-9a2e-24e8cc5f67eb.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two-story home at Quinn Residences at Dorchester Place with a grey roof, covered front porch and small front yard"
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
